import Text from "common/Typography/Text";
import React from "react";
import { AuthTwoFAStepComponent } from "features/settings/Security/TwoFA/types";
import { TwoFAFooter } from "features/settings/Security/TwoFA/TwoFAFooter";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { CopyToClipboardButton } from "common/CopyToClipboard/CopyToClipboard";
import Flex from "common/Boxes/Flex";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { typography } from "@shared/common/Themes/typography";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { useTheme } from "styled-components";

export const StepTwo: AuthTwoFAStepComponent = ({
  onUpdateStepStatus,
  index,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const refreshToken = useSelector(
    sharedLib.selectors.authentication.selectRefreshToken
  );
  const isDarkMode = useSelector(selectIsDarkMode);
  const theme = useTheme();

  const {
    data: qrCodeResponse,
    isError,
    isLoading,
    isSuccess,
  } = sharedLib.sharedApi.authentication.useGenerateQRCodeQuery({
    refresh_token: refreshToken,
  });

  if (isError) onUpdateStepStatus("error", index, t("two_fa.step_two_error"));

  const showQRCode = () => {
    if (!isMobile) {
      return (
        <img
          style={{
            maxHeight: 150,
            filter: isDarkMode ? "invert(100%)" : "none",
          }}
          src={`data:image/svg+xml;base64,${qrCodeResponse?.qrcode}`}
        />
      );
    } else {
      return (
        qrCodeResponse && (
          <Flex
            $alignItems="center"
            $flexDirection="column"
            style={{ width: "100%", marginTop: 20 }}
          >
            <Text
              $weight={
                theme.isNewLook
                  ? theme.typography.fontWeights.MEDIUM
                  : theme.typography.fontWeights.BOLD
              }
            >
              {qrCodeResponse.setup_key}
            </Text>
            <CopyToClipboardButton
              name={t("two_fa.setup_key")}
              style={{ marginTop: 8 }}
              text={qrCodeResponse.setup_key}
            />
          </Flex>
        )
      );
    }
  };

  const getUserInstructionText = () => {
    const text = isMobile
      ? t("two_fa.step_two_key_instruction")
      : t("two_fa.step_two_qr_instruction");
    return (
      <Text
        style={{ textAlign: "center" }}
        $weight={
          theme.isNewLook
            ? typography.fontWeights.NORMAL
            : typography.fontWeights.MEDIUM
        }
      >
        {text}
      </Text>
    );
  };

  return (
    <>
      {getUserInstructionText()}
      <LoadingSpinnerOverlay
        hideContentWhileLoading={true}
        isLoading={isLoading}
      >
        {showQRCode()}
      </LoadingSpinnerOverlay>
      <TwoFAFooter
        disabled={isError}
        onClick={() => {
          if (isSuccess) onUpdateStepStatus("finish", index);
        }}
      >
        {t("two_fa.next_button")}
      </TwoFAFooter>
    </>
  );
};
